export default __webpack_public_path__ + "assets/media/f0bb62a885d8440ab1057cc26dc23dcb.png";